import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {MENU_ITEMS} from "./data/menu.items";
import {JwtHelperService} from "@auth0/angular-jwt";
import {environment} from "../../environments/environment";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmationDialog} from "../_shared/dialog/confirmation.dialog";
import {ProfileMessage} from "../_services/profile.message";

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['dashboard.scss']
})
export class SidenavComponent implements OnInit, AfterViewInit {
    @Input() isExpanded: boolean;
    @Output() clicked = new EventEmitter<boolean>();
    @Output() urlClicked = new EventEmitter<string>();
    public menu = MENU_ITEMS;
    urlActive = '/user-dashboard'
    isLogin = false;
    profile: any = null;
    public policies: any[] = [];

    constructor(
        private router: Router,
        private jwtHelper: JwtHelperService,
        private dialog: MatDialog,
        private profileMsg: ProfileMessage,
    ) {
    }

    ngOnInit(): void {
        this.profileMsg.currentMessage.subscribe(r => {
            this.menu = [...MENU_ITEMS];
            if(r) {
                this.logic(r);
            }
        })
    }

    ngAfterViewInit() {
        this.router.events.subscribe((evt) => {
            this.urlActive = '/'+this.router.parseUrl(this.router.url).root.children.primary.segments[0].path;

            if (!(evt instanceof NavigationEnd)) {
                return;
            }

            if(this.urlActive != evt.url) {
                this.urlActive = '/'+this.router.parseUrl(this.router.url).root.children.primary.segments[0].path;
            }
            window.scrollTo(0, 0);

        });
    }

    logic(r: any) {
        this.isLogin = !this.jwtHelper.isTokenExpired();
        if(this.isLogin) {

            this.profile = r;
            const roles = this.profile.roles as string[];
            if (!roles.includes('ROLE_BRAND')) {
                const idx = this.menu.findIndex(m => m.group == 'AMBASSADOR');
                this.menu.splice(idx, 1);
            }
            if (!roles.includes('ROLE_ADMIN')) {
                const idx = this.menu.findIndex(m => m.group == 'ADMINISTRATOR');
                this.menu.splice(idx, 1);
            }
        }

        this.policies = this.menu;

    }
    externalLoad(url: string): void {
        this.clicked.emit(true);
        window.open(url, '_blank');
    }
    clickMenu(url: string): void {
        this.urlActive = url;
        this.redirectTo(url);
    }

    redirectTo(uri: string): void {
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
            this.router.navigate([uri]));
    }

    logout(): void {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                buttonCancelLabel: 'Cancel',
                buttonOkLabel: 'Logout',
                message: 'Are you sure you want to log out of your wallet?',
                subMessage: ''
            }
        });
        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                localStorage.removeItem("token");
                localStorage.clear();
                window.location.href = environment.home;
            }
        })


    }
}
